import ExecAPI from 'appRoot/api/api';

export function GetPendingAdoptions()
{
	return ExecAPI("AddAgentData/GetPendingAdoptions");
}
export function ApproveAdoption(adoption, cmsRole, environmentName)
{
	return ExecAPI("AddAgentData/ApproveAdoption", { adoption, cmsRole, environmentName });
}